import { defineMessages } from 'react-intl';

export default defineMessages({
  shippingStep: {
    id: 'StepCheckout.step.shipping',
    defaultMessage: 'Shipping',
  },
  deliveryMethodsStep: {
    id: 'StepCheckout.step.deliveryMethods',
    defaultMessage: 'Delivery',
  },
  paymentStep: {
    id: 'StepCheckout.step.payment',
    defaultMessage: 'Payment',
  },
  reviewStep: {
    id: 'StepCheckout.step.review',
    defaultMessage: 'Review Order',
  },
  confirmStep: {
    id: 'StepCheckout.step.confirm',
    defaultMessage: 'Place Order',
  },
  errorTitle: {
    id: 'StepCheckout.errorTitle',
    defaultMessage: 'You caught us sleeping',
  },
  accountLoginLinkBlockTitle: {
    id: 'StepCheckout.step.accountLoginLinkBlockTitle',
    description: 'Account Login link block title',
    defaultMessage: 'Already have an account?',
  },
  accountLoginLinkBlockTitleShopPay: {
    id: 'StepCheckout.step.accountLoginLinkBlockTitleShopPay',
    description: 'Account Login link block title for Shop Pay',
    defaultMessage: 'Contact',
  },
  customerCartMergedTitle: {
    id: 'StepCheckout.step.customerCartMergedTitle',
    description:
      'Unauthenticated cart is merged with customer cart after log in',
    defaultMessage: 'You’re SIGNED In',
  },
  customerCartMergedMessage: {
    id: 'StepCheckout.step.customerCartMergedMessage',
    description:
      'Message to show when unauthenticated cart is merged with customer cart after log in',
    defaultMessage:
      'If you had different items in your cart while shopping before signing in, please double check your cart before checking out.',
  },
  expressTitle: {
    id: 'StepCheckout.expressTitle',
    description: 'Express checkout label',
    defaultMessage: 'Express Checkout',
  },
  processingPayment: {
    id: 'StepCheckout.processingPayment',
    description: 'processing payment',
    defaultMessage: 'Processing payment...',
  },
  orderSummaryTitle: {
    id: 'StepCheckout.OrderSummary.title',
    description: 'Order Summary title',
    defaultMessage: 'Order Summary',
  },
  couponCodeRedeemedValidityError: {
    id: 'StepCheckout.couponCodeRedeemedValidityError',
    description: 'Coupon is already used',
    defaultMessage:
      'That promo code has already been redeemed and please remove it from the cart to place the order.',
  },
  couponCodeValidityError: {
    id: 'StepCheckout.couponCodeValidityError',
    description: 'Invalid Coupon is already used',
    defaultMessage:
      'Invalid promo code. Please remove it from the cart to place the order.',
  },
});
